const STEPS = [
  {
    n: "01",
    title: "Discovery call",
    desc: "A 30-minute conversation to understand your property, the day-to-day challenges and where you want the business to go.",
  },
  {
    n: "02",
    title: "Deep analysis",
    desc: "A full audit of pricing, listings, operations, competitors and financials — built from your actual numbers, not assumptions.",
  },
  {
    n: "03",
    title: "Executive report",
    desc: "A detailed written report covering findings, opportunities for development and growth, and identified cost savings.",
  },
  {
    n: "04",
    title: "90 day action plan",
    desc: "A prioritised roadmap with specific, implementable recommendations — plus structured follow-up so the plan actually gets executed.",
  },
];

export default function Process() {
  return (
    <section
      id="approach"
      data-testid="process-section"
      className="relative py-24 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-10 h-px bg-[#C2A878]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
                The Approach · Revenue is science
              </span>
            </div>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white tracking-tight">
              Four steps.
              <br />
              <em className="text-[#C2A878] not-italic">No theory.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-white/65 text-base md:text-lg leading-relaxed">
              We treat accommodation revenue the way the disciplines that take
              it seriously do — as a measurable, repeatable science. Diagnose,
              report, act, review.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="bg-[#050505] p-8 md:p-10 hover:bg-[#0A0D10] transition-colors duration-500"
            >
              <div className="font-serif text-6xl text-[#C2A878]/30 leading-none">
                {s.n}
              </div>
              <h3 className="mt-8 font-serif text-2xl text-white">{s.title}</h3>
              <p className="mt-4 text-sm text-white/60 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        <figure className="mt-20 md:mt-24 max-w-4xl">
          <blockquote
            data-testid="approach-pullquote"
            className="font-serif font-light italic text-3xl md:text-5xl leading-[1.1] text-white tracking-tight"
          >
            &ldquo;The most expensive system is the one you&apos;re currently
            <span className="text-[#C2A878] not-italic"> operating.</span>&rdquo;
          </blockquote>
          <figcaption className="mt-6 flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-white/45 font-semibold">
            <span className="block w-8 h-px bg-[#C2A878]" />
            Black Rock Hospitality
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
